<template>
  <div class="page greyBg">
    <!--顶部-->
    <pageTitle title="提示" RightImgName="home"/>
    <!-- 活动房 -->
    <!--倒计时（30分以内显示）-->
    <div
      class="countdown whiteBg"
      v-if="!IsLoading && seconds <= 1800 && seconds > 0 && OrderDetails.IsSpecialRoom"
    >
      <img src="../../../static/payOrder/hourglass.png">
      <div class="right">
        <div class="title">倒计时&nbsp;{{downMinutes}}:{{downSeconds}}</div>
        <div>请在30分钟内完成支付，超时未支付将自动取消。</div>
      </div>
    </div>
    <!--取消订单（小于0显示）-->
    <div
      class="countdown whiteBg"
      v-else-if="!IsLoading && seconds <= 0 && OrderDetails.IsSpecialRoom "
    >
      <img src="../../../static/hotel/打叉.png">
      <div class="right">
        <div class="title">订单已取消</div>
        <div>由于您未在规定的时间内完成支付，订单已取消。</div>
      </div>
    </div>

    <!-- 非活动房常规显示 -->
    <div class="countdown whiteBg" v-else>
      <img src="../../../static/hotel/打钩.png">
      <div class="right">
        <div class="title">预订成功，待支付</div>
        <div>如未完成预付，您的订单将保留至{{holdTime}}</div>
      </div>
    </div>

    <!--订单详情-->
    <div class="orderMsg whiteBg">
      订单号：
      <span>{{ g_PayOrder.OrderId }}</span>

      <div>
        总&nbsp;&nbsp; 价：
        <span>￥&nbsp;{{ g_PayOrder.Money | fomatFloat}}</span>
      </div>

      <div
        v-if=" OrderDetails.SpecialCode == 'C0000001' || OrderDetails.SpecialCode == 'C0000075'  || OrderDetails.SpecialCode == 'C0000187'  "
      >
        备&nbsp;&nbsp; 注：
        <span>入住日前一天18：00前可免费取消，逾期或未入住需收取全额房费作为违约金。</span>
      </div>
    </div>
    <!--加载图-->
    <div v-if="IsLoading" style=" width:100% " align="center">
      <img
        src="../../../static/LoadingBest.gif"
        style=" width:1.2rem ; margin:2.1rem auto 0 auto"
        v-show="  IsLoading  "
      >
    </div>
    <!--主要内容-->
    <div class="main whiteBg" v-if="!IsLoading ">
      <!--钱包信息-->
      <div class="wallet">
        <div class="title">我的钱包</div>
        <div class="detail">
          <span>K币</span>
          <span class="amount">{{g_walletInfo.KCoin}}</span>
          <span>储值卡</span>
          <span class="amount">{{g_walletInfo.StoreCardMoney}}元</span>
        </div>
      </div>
      <!--支付方式-->
      <div class="payType">
        <div class="title" style="float:left">支付方式</div>
        <div
          class="title"
          style="float:right  ;  font-size:0.22rem ; color:#999999 ;padding-top:0.08rem "
        >
          <img
            src="../../../static/payOrder/tick.png"
            style="height:0.2rem ; margin-bottom:-0.02rem ; padding-right:0.06rem"
          > 全额可退，优先选房，迅捷入住
        </div>

        <mu-list v-if="normalPage" style="font-size:0.3rem">
          <mu-divider/>
          <mu-list-item v-if="loginState" v-on:click="goPay(1)">
            <img
              src="../../../static/order/SmallStore.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">
              储值卡支付
              <nobr class="Orange" style="  ">充1000送1000K币</nobr>
            </span>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-divider/>
          <mu-list-item v-on:click="goPay(2)" v-if="loginState">
            <img
              src="../../../static/order/SmallUnionPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-list-item v-on:click="goPay(5)" v-else>
            <img
              src="../../../static/order/SmallUnionPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-divider/>
          <mu-list-item v-on:click="goPay(3)" v-bind:style="{display:allowAlipay}">
            <img
              src="../../../static/order/SmallAlipay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
            <span class="title">支付宝支付</span>
          </mu-list-item>
          <mu-divider v-bind:style="{display:allowAlipay}"/>
          <mu-list-item v-on:click="goPay(6)" v-bind:style="{display:allowWepay}">
            <img
              src="../../../static/order/wepay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" color="#efefef" value="keyboard_arrow_right"/>
            <span class="title">微信支付</span>
          </mu-list-item>
          <mu-divider v-bind:style="{display:allowWepay}"/>
          <!-- 
          <mu-list-item v-on:click="goPay(4)">
            <img
              src="../../../static/order/SmallOtherPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" color="#efefef" value="keyboard_arrow_right"/>
            <span class="title">他人代付</span>
          </mu-list-item>
          -->
          <mu-divider/>
        </mu-list>

        <mu-list v-if="jdPage" style="font-size:0.3rem;">
          <mu-divider/>
          <mu-list-item v-if="loginState" v-on:click="goPay(1)">
            <img
              src="../../../static/order/SmallStore.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">
              储值卡支付  
             </span>
             <div>
                <nobr class="Orange" style="font-size: 0.25rem;color:#ff6a6a;">充1000送1000K币</nobr>
              </div>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-divider/>
          <mu-list-item v-on:click="goPay(2)" v-if="loginState">
            <img
              src="../../../static/order/SmallUnionPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-list-item v-on:click="goPay(5)" v-else>
            <img
              src="../../../static/order/SmallUnionPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">银联支付</span>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-divider/>
          <mu-list-item v-on:click="goPay(6)">
            <img
              src="../../../static/order/wepay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" color="#efefef" value="keyboard_arrow_right"/>
            <span class="title">微信支付</span>
          </mu-list-item>
          <mu-divider/>
          <mu-list-item v-on:click="goPay(7)">
            <img
              src="../../../static/order/Smalljd.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" color="#efefef" value="keyboard_arrow_right"/>
            <span class="title">京东支付</span>
            <div>
              <nobr class="Orange" style="font-size: 0.25rem;color:#ff6a6a;">开通白条立减30 老客随机立减</nobr>
            </div>
          </mu-list-item>
          <mu-divider/>
        </mu-list>

        <mu-list v-if="ysfPage" style="font-size:0.3rem;">
          <mu-divider/>
          <mu-list-item v-if="loginState" v-on:click="goPay(1)">
            <img
              src="../../../static/order/SmallStore.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <span class="title">
              储值卡支付  
             </span>
             <div>
                <nobr class="Orange" style="font-size: 0.25rem;color:#ff6a6a;">充1000送1000K币</nobr>
              </div>
            <mu-icon slot="right" value="keyboard_arrow_right" color="#efefef"/>
          </mu-list-item>
          <mu-divider/>
         
          <mu-list-item v-if="loginState"  v-on:click="goPay(8)">
            <img
              src="../../../static/order/YsfPay.png"
              style="width:0.6rem"
              backgroundColor="transparent"
              slot="left"
            >
            <mu-icon slot="right" color="#efefef" value="keyboard_arrow_right"/>
            <span class="title">云闪付</span>
            <div>
                 <!-- <nobr class="Orange" style="font-size: 0.25rem;color:#ff6a6a;">满150元随机立减20-50元</nobr> -->
              </div>
          </mu-list-item>
          <mu-divider/>
        </mu-list>

      </div>
    </div>

    <!--弹出框-->
    <mu-toast v-if="toast" :message="TellUser" @close="hideToast" id="alertline"/>

    <mu-dialog :open="dialog" @close="close">
      <div style="color:#666666;text-align:center;">抱歉，您尚未开通储值卡！</div>
      <mu-flat-button slot="actions" @click="goOpenValue" primary label="去开通"/>
      <mu-flat-button slot="actions" primary @click="close" label="取消"/>
    </mu-dialog>

     <!-- 表单提交 -->
     <!-- <form  id="batchForm"  method="post" runat="server" action="https://h5pay.jd.com/jdpay/saveOrder">
          <input type="text"  name="version" id="version" runat="server" v-model="JdpayInfo.version">
          <input type="text"  name="merchant" id="merchant" runat="server" v-model="JdpayInfo.merchant">
          <input type="text"  name="device" id="device" runat="server" v-model="JdpayInfo.device">
          <input type="text"  name="tradeNum" id="tradeNum" runat="server" v-model="JdpayInfo.tradeNum">
          <input type="text"  name="tradeName" id="tradeName" runat="server" v-model="JdpayInfo.tradeName">
          <input type="text"  name="tradeDesc" id="tradeDesc" runat="server"  v-model="JdpayInfo.tradeDesc">
          <input type="text"  name="tradeTime" id="tradeTime" runat="server"  v-model="JdpayInfo.tradeTime">
          <input type="text"  name="amount" id="amount" runat="server"  v-model="JdpayInfo.amount">
          <input type="text"  name="currency" id="currency" runat="server"  v-model="JdpayInfo.currency">
          <input type="text"  name="note" id="note" runat="server"  v-model="JdpayInfo.note">
          <input type="text"  name="callbackUrl" id="callbackUrl" runat="server"  v-model="JdpayInfo.callbackUrl">
          <input type="text"  name="notifyUrl" id="notifyUrl" runat="server"  v-model="JdpayInfo.notifyUrl">
          <input type="text"  name="ip" id="ip" runat="server"  v-model="JdpayInfo.ip">
          <input type="text"  name="specCardNo" id="specCardNo" runat="server"  v-model="JdpayInfo.specCardNo">
          <input type="text"  name="specId" id="specId" runat="server"  v-model="JdpayInfo.specId">
          <input type="text"  name="specName" id="specName" runat="server"  v-model="JdpayInfo.specName">
          <input type="text"  name="userId" id="userId" runat="server"  v-model="JdpayInfo.userId">
          <input type="text"  name="expireTime" id="expireTime" runat="server"  v-model="JdpayInfo.expireTime">
          <input type="text"  name="orderType" id="orderType" runat="server"  v-model="JdpayInfo.orderType">
          <input type="text"  name="industryCategoryCode" id="industryCategoryCode" runat="server"  v-model="JdpayInfo.industryCategoryCode">
          <input type="text"  name="sign" id="sign" runat="server"  v-model="JdpayInfo.sign">
    </form> -->


  </div>
</template>


<script>
import { mapMutations, mapGetters } from "vuex";
import api from "../../api";
import pageTitle from "../../components/pageTitle";
import orderHelper from "../../utils/order";
import order from "../../utils/order";
//import VueCupUi from '../../node_modules/vue-cup-ui';
//import '../../vue-cup-ui/lib/vue-cup-ui.css';

export default {
  computed: {
    ...mapGetters(["g_UserInfo", "g_PayOrder", "g_walletInfo"])
  },
  activated() {
    this.allowWepay = typeof WeixinJSBridge == "undefined" ? "none" : "block";
    this.allowAlipay = typeof WeixinJSBridge == "undefined" ? "block" : "none";

    var newUrl = sessionStorage.getItem(window.location.hostname + "_homeUrl");
    console.log(this.normalPage);
    //console.log(22222222);
    console.log(newUrl);
    if(newUrl!=null && newUrl != undefined && newUrl!='' && newUrl.search('/home/jdindex')!=-1){
      console.log(1);
      this.jdPage = true;
      this.normalPage = false;
    }
    else {
      console.log(2);
      this.jdPage = false;
      this.normalPage = true;
    }
    var newUrltype = sessionStorage.getItem(window.location.hostname + "_hometype");
    if(newUrltype!=null && newUrltype != undefined && newUrltype!='' && newUrltype.search('ysf')!=-1)
    {
      console.log(3);
      this.ysfPage = true;
      this.jdPage = false;
      this.normalPage = false;

    }
    this.QuickPay = 0;

    this.valueOpen = false;
    if (this.g_walletInfo.KCoin == "") {
      this.GetMyWallet();
    }    
    console.log(this.normalPage);
    console.log(this.jdPage);
    console.log(this.ysfPage);
   
    this.IsLoading = true;

    // if (this.hisResvOrder === null || this.hisResvOrder !== this.g_PayOrder.OrderId) {
    // this.GetWaitingForPay();
    // }

    this.checkValueCard();
    //获取登录状态
    var params = new this.URLSearchParam();
    params.append(
      "cardNo",
      this.g_UserInfo.Card_no ? this.g_UserInfo.Card_no : ""
    );
    this.$http.post(api.loginState(), params.toParam()).then(res => {
      if (res.Result) {
        this.loginState = true;
      } else {
        // this.$http.post(api.LogOff()).then((res) => { });
        // this.$store.commit('CLEARUSER');
        this.loginState = false;
      }
    });
    //登录成功在获取支付金额
    this.GetWaitingForPay();
    // 非会员 ， 半小时内支付，会员，休闲房，活动房，半小时内支付 。    会员 非活动房 常规支付
  },
  deactivated() {
    //离开页面清除计时器
    //clearInterval(this.timer)
  },
  data() {
    return {
      IsLoading: true,

      loginState: false,

      dialog: false,

      QuickPay: 0,

      // 储值卡开通状态
      valueOpen: false,

      // 弹出层
      TellUser: "",
      toast: false,
      // 弹出标签 选择是否
      dialog: false,
      //计时器
      timer: "",
      //剩余秒数
      seconds: 0,
      //倒计时分钟
      downMinutes: 0,
      //倒计时秒数
      downSeconds: 0,
      holdTime: "",
      allowWepay: typeof WeixinJSBridge == "undefined" ? "none" : "block",
      allowAlipay: typeof WeixinJSBridge == "undefined" ? "block" : "none",
      //上个订单号
      // hisResvOrder: null

      normalPage:true,
      jdPage:false,
      ysfPage:false,

      // 所有数据
      OrderDetails: "",

      JdpayInfo: {},
    };
  },

  // upsdk.pluginReady (function(){
  //  // 前端API调用  
  //       upsdk.setTitleStyle({
  //           // 可选，导航栏(含状态栏)背景色及透明度。16进制，前2位(8F)透明度，后六位(FFFFFF)颜色，仅对当前页有效，其余页还是申请配置的导航默认颜色。
  //           navBackgroundColor:'0x8FFFFFFF', 
  //           appletStyle: 'black', //可选，black-黑色主题，white-白色主题。 
  //           backBtnVisible: ‘0’, // 可选，左侧返回按钮是否显示。’0’不显示，’1’显示，不传或空则默认显示 
  //           appletTitleBarVisible: ‘1’, // 可选，标题栏是否显示。’0’不显示，’1’显示，默认显示
  //           appletTitleGradientOrient：‘top’, // 可选，渐变色方向，支持top、bottom、left、right
  //           appletTitleGradientStartColor:'0x8FFFFFFF'，//渐变起始颜色
  //           appletTitleGradientEndColor：'0x88888888' //渐变结束颜色
  //       });

  //       upsdk.setNavigationBarTitle({    
  //        title: '设置云闪付标题'
  //       }); 
         
  //       upsdk.pay({
  //           tn: '支付流水号Ticket Number',
  //           success: function(){
  //               // 支付成功, 开发者执行后续操作。
  //           },
  //           fail: function(err){
  //               // 支付失败, err.msg 是失败原因描述, 比如TN号不合法, 或者用户取消了交易 等等。
  //           }
  //       });
  // });
  methods: {
    ...mapMutations(["setG_PayOrder", "setG_walletInfo","setG_jdpay"]),
    //开通储值卡
    goOpenValue() {
      this.close();
      this.$router.push({ path: "/wallet/openValueCard" });
    },
    //倒计时
    downTime() {
      if (this.seconds > 0) {
        this.seconds -= 1;
        this.downMinutes = Math.floor(this.seconds / 60);
        this.downSeconds = this.seconds - this.downMinutes * 60;
      }
    },
    //设置倒计时
    setTimer(hotelCode, isSp, opTime, holdTime) {
      var today = new Date(); //当前时刻
      this.holdTime = new Date(holdTime).Format("YYYY-MM-dd hh:mm");
      this.seconds = Math.floor((holdTime - today.getTime()) / 1000); //时间差的秒数

      if (isSp) {
        //设置成30*60(now - opTine) 倒计时
        this.holdTime = new Date(opTime + 30 * 60 * 1000).Format(
          "YYYY-MM-dd hh:mm"
        );
        this.seconds = 30 * 60 - Math.floor((today.getTime() - opTime) / 1000); //时间差的秒数

        this.downMinutes = Math.floor(this.seconds / 60);
        this.downSeconds = this.seconds - this.downMinutes * 60;
        this.timer = setInterval(this.downTime, 1000);
      }
    },
    GetWaitingForPay() {
      //显示加载
      this.IsLoading = true;
      //清除定时器
      clearInterval(this.timer);
      // 这就是获取订单价格的接口
      var params = new this.URLSearchParam();
      params.append("parentNo", this.g_PayOrder.OrderId);

      this.$http.post(api.GetWaitingForPay(), params.toParam()).then(res => {
        if (res.Result) {
          console.log(this.g_PayOrder);
          var Order = this.g_PayOrder;
          // Order.PayFor = "PayMent";
          Order.Money = res.Data;
          this.setG_PayOrder(Order);
          //console.log(this.g_PayOrder.Money);
          this.hisResvOrder = Order.OrderId;

          this.IsLoading = false;
        } else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      });

      // 获取是否用了银联券
      var params = new this.URLSearchParam();
      params.append("parentNo", this.g_PayOrder.OrderId);
      params.append("phoneNo", this.g_UserInfo.OtherUserID);

      this.$http.post(api.getOrderDetail(), params.toParam()).then(res => {
        if (res.Result) {
          console.log(res.Data);

          this.OrderDetails = res.Data;

          var orderState = orderHelper.getOrderOption(res.Data);
          //此订单不能支付
          if (!orderState.showPay) {
            this.TellUser = "此订单状态不能支付！";
            this.showToast();
            var that = this;
            setTimeout(function() {
              that.$router.push({ path: "/home/order" });
            }, 1200);
          }
          // if(res.Data.IsSpecialRoom){
          this.setTimer(
            res.Data.HotelCode,
            res.Data.IsSpecialRoom,
            parseInt(res.Data.Operatordate.substring(6, 19)),
            parseInt(res.Data.HoldTime.substring(6, 19))
          );
          // }
          this.IsLoading = false;
          var Order = this.g_PayOrder;
          Order.TypeId = 0;
          Order.UsingUnionCash = res.Data.UsingUnionCash;
          Order.IsSpecialRoom = res.Data.IsSpecialRoom;

          this.setG_PayOrder(Order);

          // 登录的用户，房间不是休闲房，也不是活动房
          if (
            this.loginState == true &&
            !this.g_PayOrder.IsSpecialRoom &&
            res.Data.Note.indexOf("[休闲房]") == -1
          ) {
            this.QuickPay = 1;
          } else {
            this.QuickPay = 2;
          }
        } else {
          //调用弹出层
          this.TellUser = res.Message;
          this.showToast();
        }
      });
    },
    //跳转登录页面
    goLogin() {
      var that = this;
      setTimeout(function() {
        that.$router.push({ path: "/user/Login" });
      }, 2000);
    },
    //检查储值卡是否开通，开通跳转否则弹出对话框
    checkValueCard() {
      if (typeof this.g_UserInfo.HasOpenStoreCard === "undefined") {
        this.TellUser = "您的用户信息已过期，请重新登录！";
        this.showToast();
        //清空信息缓存
        this.$store.commit("CLEARUSER");
        //跳转登录
        this.goLogin();
        return;
      } else {
        this.valueOpen = this.g_UserInfo.HasOpenStoreCard;
      }
    },

    goPay(val) {
      if (val == 1 || val == 3 || val == 4) {
        if (this.g_PayOrder.UsingUnionCash == undefined) {
          this.TellUser = "正在获取信息";
          this.showToast();
          return;
        }
        if (this.g_PayOrder.UsingUnionCash) {
          this.TellUser = "请用银联支付";
          this.showToast();
          return;
        }
      }

      var Order = this.g_PayOrder;

      if (val == 1) {
        if (!this.valueOpen) {
          this.open();
          return;
        }
        Order.PayType = "储值卡支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: "/order/PayByStoredValueCard" });
      } else if (val == 2) {
        Order.PayFor = "PayMent";

        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);

        this.$router.push({ path: "/order/PayByUnion/ChooseCard" });
      } else if (val == 3) {
        Order.PayType = "支付宝支付";
        this.setG_PayOrder(Order);
        // this.$router.push({ path: '/PayMent/AliPay?parentNo='+  this.g_PayOrder.OrderId  +'&orderType=1' });

        window.location.href =
          "/apis/PayMent/PayByAlipay?parentNo=" +
          this.g_PayOrder.OrderId +
          "&orderType=0";
      } else if (val == 4) {
        Order.PayType = "他人支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: "/order/PayByOther" });
      } else if (val == 5) {
        // 未登录用户点击，不跳入选卡页面，直接去输入卡号
        Order.PayFor = "PayMent";
        Order.PayType = "银联支付";
        this.setG_PayOrder(Order);
        this.$router.push({ path: "/order/PayByUnion/BeforeBind" });
      } else if (val == 6) {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx384b5da598edc120&redirect_uri=http://h5.998.com/kosmos/apis/WeChat/GetCodeReturn&response_type=code&scope=snsapi_base&state=" +
          this.g_PayOrder.OrderId +
          "_0_" +
          this.g_PayOrder.Money +
          "_I998#wechat_redirect";
      }else if(val==7)
      {
        Order.PayType = "京东支付"; 
        this.setG_PayOrder(Order);

        // 根据订单单号获取订单详信息，需要加密后的
        var params = new this.URLSearchParam();
        params.append("parentNo",this.g_PayOrder.OrderId );
        this.$http.post(api.JdpayH(), params.toParam()).then(res => {
            if (res.Result) {
               this.JdpayInfo = res.Data
               this.setG_jdpay(this.JdpayInfo);
               this.$router.push({ path: "/payOrder/Jdpay" });
               //document.getElementById("batchForm").submit()
          
                //this.submitFrom.submit();
              //  $("#batchForm").actions="https://h5pay.jd.com/jdpay/saveOrder";
              //  $("#batchForm").submit()
            }
        });
      }else if(val==8)
      {
        // 调用后端API接口获取 云闪付tn 支付流水号TN号
        var params = new this.URLSearchParam();  // 根据订单单号获取TN单号
        params.append("parentNo",this.g_PayOrder.OrderId);
        this.$http.post(api.Cloudpay(), params.toParam()).then(res => {
        if (res.Result) {
             
             console.log(res.Data.TransactionNo);
                console.log("云闪付支付");
                //debugger;
                var tnNo=res.Data.TransactionNo;
                upsdk.pluginReady (function(){
                upsdk.pay({
                      tn: tnNo,
                      success: function(){
                        console.log("支付成功!");
                          // 支付成功, 开发者执行后续操作。
                      },
                      fail: function(err){
                          console.log("支付失败!");
                          // 支付失败, err.msg 是失败原因描述, 比如TN号不合法, 或者用户取消了交易 等等。
                      }
                  });
            });
          }
      });

      //    Order.PayFor = "PayMent";
      //    Order.PayType = "云闪付";
      //    this.setG_PayOrder(Order);
 
      //  // 根据订单单号获取订单详信息，需要加密后的
      //   var params = new this.URLSearchParam();
      //   params.append("parentNo",this.g_PayOrder.OrderId );
      //   this.$http.post(api.JdpayH(), params.toParam()).then(res => {
      //       if (res.Result) {
      //          this.JdpayInfo = res.Data
      //          //this.setG_jdpay(this.JdpayInfo);
      //          //this.$router.push({ path: "/payOrder/Jdpay" });
      //       }
      //   });
      }
    },

    goback() {
      alert(0);
      javascript: history.go(-1);
    },

    // 弹出层
    showToast() {
      this.toast = true;
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toastTimer = setTimeout(() => {
        this.toast = false;
      }, 1000);
      if (this.TellUser == "未登录") {
        this.$http.post(api.LogOff()).then(res => {});
        this.$store.dispatch("clearUser");
        this.toastTimer = setTimeout(() => {
          this.$router.push({ path: "/user/login" });
        }, 1200);
      }
    },
    hideToast() {
      this.toast = false;
      if (this.toastTimer) clearTimeout(this.toastTimer);
    },
    // 弹出层  end

    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    GetMyWallet() {
      this.$http.post(api.GetMyWallet()).then(res => {
        if (res.Result) {
          this.setG_walletInfo(res.Data);
        }
      });
    }
  },

  watch: {
    // $route(to, from) {
    //   if (from.path != "/home/order" && from.path != "/search/makeOrder" && from.path != "/order/OrderDetails" && from.path != "/order/wepay") {
    //     this.$router.push({ path: '/home/order' });
    //   }
    // },
  },
  components: {
    pageTitle
  }
};
</script>




// paper模块
<style lang="less" scoped>
@import "../../assets/theme.less";
.page {
  height: auto;
  overflow: hidden;
}

.countdown {
  display: flex;
  padding: 0.2rem 0.3rem;
  color: #666666;
  font-size: 0.22rem;
  border-bottom: 1px solid #eeeeee;
  img {
    width: 0.6rem;
    height: 0.6rem;
    margin: auto 1em auto 0;
  }
  .right {
    margin: auto 0;
    .title {
      color: @primaryColor;
      font-size: 0.32rem;
    }
  }
}

.orderMsg {
  font-size: 0.26rem;
  padding: 0.2rem;
  line-height: 2em;
  span {
    color: #333333;
  }
}

.main {
  .mu-list {
    padding: 0;
    .title {
      color: #333333;
    }
  }
  margin-top: 0.2rem;
  padding: 0.2rem 0.2rem 0 0.2rem;
  .wallet {
    display: flex;
    justify-content: space-between;
    background-color: #fcf8f5;
    border-radius: 4px;
    border: 1px solid #f4e9e2;
    font-size: 0.26rem;
    padding: 0.2rem;
    .title {
      color: #333333;
    }
    .amount {
      color: @darkOrange;
      font-size: 0.3rem;
      margin: 0 0.2rem 0 0.1rem;
    }
  }
  .payType {
    > .title {
      color: #666666;
      font-size: 0.32rem;
      margin: 0.3rem;
    }
  }
}

.demo-paper {
  // 横向显示
  /*display: inline-block;*/
  margin: 8px;
  text-align: center;
  margin-top: 10px;
}

.green {
  color: @primaryColor;
  border: 1px solid @primaryColor;
}

.pageContent {
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;

  color: @textColor; // 顶部标签变换
  .header {
    width: 100%;
  }
  .mu-tabs {
    // 背景色
    background-color: #fff;
  } // 未选中时候的颜色
  .mu-tab-link {
    color: #999999;
    font-weight: bold;
  } //  选中  分页的
  .mu-tab-active {
    color: @primaryColor;
    font-weight: bold;
  } // END 顶部标签变换
  .Orange {
    color: @primaryOrange;
  }
  .Black {
    color: @primaryBlack;
  }
  .Grey {
    color: @textColor;
  }
}
</style>





// WEBPACK FOOTER //
// payType.vue?219d8eb0